import Component from '~/components/component';
import Flickity from "flickity";
import AnimRounding from './anim-rounding';
import VideoTmp from '../components/video-tmp/video-tmp'
import States from './states'

export default class PatheSlider {
    constructor(component) {

        this.dom = {
            component
        }

        this._retrieveDOM();

        this.params = {
            current: 0,
            next: 0,
            canClick: true,
            total: this.dom.slides.length,
            textHeight: 0
        }

        this.test = 0;
        this.test2 = 0;
        this.testTotal = 5;
    }

    _retrieveDOM() {
        this.dom.sliderContainer = this.dom.component.querySelector('.js-slider-container');
        this.dom.textWrapper = this.dom.component.querySelector('.js-text-wrapper');
        this.dom.textContainer = this.dom.component.querySelectorAll('.js-text-container');
        this.dom.slides = this.dom.component.querySelectorAll('.js-slide');
        this.dom.images = this.dom.component.querySelectorAll(".anim-container .inner");
        this.dom.mask = this.dom.component.querySelectorAll(".anim-mask");
        this.dom.legends = this.dom.component.querySelectorAll('.js-legend');
        this.dom.copyrights = this.dom.component.querySelectorAll('.js-copyright');
        this.dom.previous = this.dom.component.querySelector('.js-direction-previous');
        this.dom.next = this.dom.component.querySelector('.js-direction-next');
        this.dom.counter = this.dom.component.querySelector('.js-counter');
    }

    bind() {

        if (ENV.template == 'desktop') {
            //Set height of container text for te first time
            // this._setHeight(this.params.current);
            
            for (let i = 0; i < this.dom.textContainer.length; i++) {
                if( this.dom.textContainer[i].getBoundingClientRect().height > this.params.textHeight ) {
                    this.params.textHeight = this.dom.textContainer[i].getBoundingClientRect().height;
                }
    
                this.dom.textWrapper.style.height = this.params.textHeight + 'px';
            }
        } else {
            this.dom.textWrapper.style.height = this.dom.textContainer[0].getBoundingClientRect().height + 'px';
        }

        //Animation rounding
        this.AnimRounding = new AnimRounding({
            container: this.dom.slides,
            mask: this.dom.mask,
            inner: this.dom.images
        }, this.params.current, this._onComplete.bind(this));

        //Event click for slider
        if (this.dom.slides.length > 1 && this.dom.previous && this.dom.next){
            this.dom.previous.addEventListener("click", this._process.bind(this, "prev"));
            this.dom.next.addEventListener("click", this._process.bind(this, "next"));
        }
    }

    _process(direction) {

        for(var componentName in States.Components){
            var component = States.Components[componentName];

            // Bind Global VideoTmp Events
            if( component.length > 0 ) {
                for( let i = 0, j = component.length; i < j; i++) {
                    let componentTab = component[i];
                    if(componentTab instanceof VideoTmp){
                        componentTab.pause()
                    }
                }
            } else {
                if(component instanceof VideoTmp){
                    component.pause()                     
                }
            }
        }

        if ( this.params.canClick == false )
            return;

        this.params.canClick = false;

        let operator = ( direction == "next" ) ? 1 : -1;
        this.params.next = loopIndex(this.params.current + operator, this.params.total);

        // console.log(this.params.current)
        // console.log(operator)
        // console.log(loopIndex(this.params.current + operator, this.params.total))

        // if ( direction == "next" && this.params.current < this.params.total){
        //     this.params.next++;
        // }
        // else if (direction == "next" && this.params.current == this.params.total) {
        //     this.params.next = 0;
        // }
        // else if (direction == "prev" && this.params.current > 0) {
        //     this.params.next--;
        // }
        // else if (direction == "prev" && this.params.current == 0) {
        //     this.params.next = this.params.total;
        // }
        this._animate();
    }

    _animate() {

        if (ENV.template == 'mobile')
            this._setHeight(this.params.next);
        
        let heightNextStep = this.dom.textContainer[this.params.next].offsetHeight;

        // animation image
        this.AnimRounding.animate(this.params.next);

        //Anim text
        TweenMax.fromTo(this.dom.textContainer[this.params.current], 0.3, {autoAlpha: 1}, {autoAlpha: 0, force3D:true, ease: Power2.easeInOut}, 0 );

        TweenMax.fromTo(this.dom.textContainer[this.params.next], 0.5, {y: -heightNextStep, autoAlpha: 1}, {y: 0, force3D:true, ease: Power2.easeInOut}, 0.2 );
    }

    _setHeight(index){
        let heightNextStep = this.dom.textContainer[index].getBoundingClientRect().height;
        // this.dom.textWrapper.style.height = this.dom.textContainer[0].getBoundingClientRect().height + 'px';
        TweenLite.to(this.dom.textWrapper, 0.5 , {height: heightNextStep, force3D:true, ease: Power2.easeInOut} );

    }

    _onComplete(indexCurrent) {
        this.params.current = indexCurrent;
        this.params.canClick = true;
        if( this.dom.counter )
            this.dom.counter.innerHTML = this.params.current + 1;
    }
    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/helpers/patheSlider.js